import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class PropertyResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  files(params = {}, next = '') {
    const urlParams = objectToUrlParams(params);
    const options = {
      url: `${this.url}/files${urlParams}`,
      ...(next && {
        headers: { 'x-wb-continuation-token': next },
      }),
    };
    return super
      .get(options)
      .then((response) => response)
      .catch((error) => error.response);
  }

  get(params = {}) {
    const urlParams = objectToUrlParams(params);
    const options = {
      url: `${this.url}${urlParams}`,
    };
    return super
      .get(options)
      .then((response) => response)
      .catch((error) => error.response);
  }

  update(data) {
    return super
      .patch(data)
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete(params = { permanent: false }) {
    const urlParams = objectToUrlParams(params);
    return super
      .delete({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
